import { LtlStop} from "../LtlStop";
import { DataSource, Layout} from "@mcleod/components";

export abstract class AutogenLayoutLtlQuoteStopDetails extends Layout {
	layoutStopTable: LtlStop;
	sourceQuoteStops: DataSource;
}
